import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'
import configs from '@/config'
import utils from '@/util'

const _state = {}
const _getters = {
  canUseAIChatbot: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-ai-chatbot')
  },

  aiChatbotUrl: (_, __, rootState) => {
    const token = utils.getCookie('ahaToken')
    const presentationId = rootState?.presentation?.id
    return `${window.location.protocol}//${configs.aiChatbotDomain}/?token=${token}&presentationId=${presentationId}`
  },
}
const mutations = {}
const actions = {}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
